<template>
  <div class="bagels">

    <h1>Are there bagels today?</h1>

    <div class="answer" :class="[answerColorClass, {loading: isAwaitingData}]">{{ answerContent }}</div>
    
    <div class="next-container">
        <h2>Next Bagel Day</h2>
        <div class="next-date" :class="[nextDateColorClass, {loading: isAwaitingData}]">{{ nextDateContent }}</div>
    </div>
    
    <div class="list-container">
        <p><a href="/list">See all bagel days</a></p>
    </div>
    
    <div class="feedback-container">
        <p><a href="/feedback">Report a problem or leave feedback</a></p>
    </div>
    
    <div class="logo-container">
        <img src="/static/logo.png" alt="Pit Crew Logo">
    </div>

    <div v-if="dataError" class="data-error">An error occurred when trying to load bagel data. Please try again later.</div>
  </div>
</template>

<script>

require('array.prototype.find').shim();

window.Promise = require('promise-polyfill');

let axios = require('axios');

let queryParams = getParams(window.location.search);

function getParams (query) {
  // https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript

  if (!query) {
    return {};
  }

  return (/^[?#]/.test(query) ? query.slice(1) : query)
    .split('&')
    .reduce((params, param) => {
      let [key, value] = param.split('=');
      params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
      return params;
    }, {});
}

function compareDates (a, b) {
  return a - b;
}

function ensureDateObj (x) {
  if (!(x instanceof Date)) x = new Date(x);

  return x;
}

function containsDate (dateArr, dateObj) {
  return dateArr.some(d => compareDates(d, dateObj) === 0);
}

function findNextDate (sortedDateArr, dateObj) {
  return sortedDateArr.find(d => compareDates(d, dateObj) > 0);
}

function todayDate () {
  let d;

  if (queryParams && queryParams.today) {
    d = new Date(queryParams.today);
  } else {
    d = new Date();
    d.setHours(0, 0, 0, 0);
  }

  return d;
}

function longDate (d) {
  let localeOptions = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  };

  return d.toLocaleString('en-us', localeOptions);
}

const ANSWERS = Object.freeze({
  YES: 'Yes',
  NO: 'No',
  UNKNOWN: '?'
});

const COLOR_CLASSES = Object.freeze({
  POSITIVE: 'text-color-positive',
  NEGATIVE: 'text-color-negative',
  NEUTRAL: 'text-color-neutral'
});

const NEXT_DATE_UNKNOWN = '?';

export default {
  name: 'Bagels',
  data () {
    return {
      remoteData: '',
      dataError: false,
      remoteUrl: `https://us-central1-bagels-today.cloudfunctions.net/bagelData`,
      exampleUrl: `/static/example.json`
    };
  },
  mounted () {
    axios.get(this.dataUrl)
      .then(response => {
        if (!this.dataError) this.remoteData = response.data;
      })
      .catch(err => {
        this.dataError = true;
        console.error(err);
      });

    setTimeout(() => {
      if (this.isAwaitingData) {
        this.dataError = true;
        console.error(
          'Request for bagel data timed out and could not be completed'
        );
      }
    }, 10000);
  },
  computed: {
    dataUrl () {
      let dataUrl = this.remoteUrl;

      if (queryParams && queryParams.example) {
        dataUrl = this.exampleUrl;
      }

      return dataUrl;
    },

    bagelDateObjs () {
      let rawData = [];

      if (this.remoteData) {
        rawData = this.remoteData.values[0];
      }

      let bagelDateObjs = rawData
        .map(d => d.trim())
        .filter(d => d)
        .map(d => ensureDateObj(d));

      bagelDateObjs.sort(compareDates);

      return bagelDateObjs;
    },

    isAwaitingData () {
      return !this.dataError && !this.remoteData;
    },

    nextDateVal () {
      return findNextDate(this.bagelDateObjs, todayDate());
    },

    answerVal () {
      let isDefinitelyBagelDay = containsDate(this.bagelDateObjs, todayDate()),
        answerVal;

      if (isDefinitelyBagelDay) answerVal = 'YES';
      else if (this.nextDateVal) answerVal = 'NO';
      else answerVal = 'UNKNOWN';

      return answerVal;
    },

    answerColorClass () {
      const colorMappings = {
          YES: 'POSITIVE',
          NO: 'NEGATIVE',
          UNKNOWN: 'NEUTRAL'
        },
        colorKey = colorMappings[this.answerVal],
        colorClass = COLOR_CLASSES[colorKey];

      return colorClass;
    },

    nextDateColorClass () {
      let colorClass = COLOR_CLASSES['NEUTRAL'];

      if (this.nextDateVal) colorClass = COLOR_CLASSES['POSITIVE'];

      return colorClass;
    },

    answerContent () {
      return ANSWERS[this.answerVal];
    },

    nextDateContent () {
      let nextDateContent;

      if (this.nextDateVal) nextDateContent = longDate(this.nextDateVal);
      else nextDateContent = NEXT_DATE_UNKNOWN;

      return nextDateContent;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
body {
  padding: 50px 30px;
  color: #82c600;
  font-weight: bold;
  text-align: center;
  font-size: 18px;
  font-family: helvetica, sans-serif;
}

a,
a:visited,
a:hover,
a:focus,
a:active {
  color: #82c600;
}

.answer {
  font-size: 60px;
}

.next-container {
  margin: 40px 0;
}

.text-color-positive {
  color: #82c600;
}

.text-color-neutral {
  color: blue;
}

.text-color-negative {
  color: #f45341;
}

.feedback-container,
.list-container {
  font-size: 16px;
  font-weight: normal;
}

.loading {
  background-image: url("/static/spinner.gif");
  background-repeat: no-repeat;
  background-position: center;
  color: transparent;
}

.data-error {
  position: absolute;
  top: 0;
  left: 0;
  color: red;
  width: 100%;
}

.logo-container img {
  width: 100px;
}
</style>


// WEBPACK FOOTER //
// src/components/Bagels.vue